<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Fiche Téléphonique Dgpo </strong>
      </b-card-header>
      <b-card-body>
        <h6>Critères de recherche</h6>
        <b-row>
          <b-col sm="5">
            <b-form-group
              label-for="dateReception"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date de réception :</b></template>
              <b-form-input class="custom-input-reduit"
                            type="date"
                            id="dateReception"
                            @paste="onPaste($event, 'receptionDebut')"
                            v-model="dateReception"
                            :class="{hasError: errors.dateReception !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateReception }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-form-group
              label-for="dateReceptionAu"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Au :</b></template>
              <b-form-input type="date"
                            id="dateReceptionAu"
                            @paste="onPaste($event, 'receptionAu')"
                            v-model="dateReceptionAu">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5">
            <b-form-group
              label-for="dateCloture"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Date de cloture :</b></template>
              <b-form-input class="custom-input-reduit"
                            type="date"
                            id="dateCloture"
                            @paste="onPaste($event, 'clotureDebut')"
                            v-model="dateCloture"
                            :class="{hasError: errors.dateCloture !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dateCloture }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="5">
            <b-form-group
              label-for="dateClotureAu"
              :label-cols="3"
              :horizontal="true">
              <template slot="label"><b>Au :</b></template>
              <b-form-input type="date"
                            id="dateClotureAu"
                            @paste="onPaste($event, 'clotureAu')"
                            v-model="dateClotureAu">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group :label-cols="1"
                          :horizontal="true">
              <template slot="label">
                <b>Commentaire</b>
              </template>
              <b-form-radio-group v-model="commentaire" class="ml-4">
                <b-form-radio value="true" class="ml-2 mt-2">Oui</b-form-radio>
                <b-form-radio value="false" class="ml-2 mt-2">Non</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button class="mt-2 mb-1 mr-1" variant="info" @click="generateExcel">Génerer</b-button>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import {isEmpty} from '@/utils/fileHelper';

  export default {
    name: "FicheTelDgpo",
    data() {
      return {
        dateReception: null,
        dateReceptionAu: null,
        dateCloture: null,
        dateClotureAu: null,
        commentaire: false,
        errors: {
          dateReception: '',
          dateReceptionAu: '',
          dateCloture: '',
          dateClotureAu: ''
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      generateExcel() {
        let self = this;
        const data = {
          date_reception: this.dateReception,
          date_reception_au: this.dateReceptionAu,
          date_cloture: this.dateCloture,
          date_cloture_au: this.dateClotureAu,
          commentaire: this.commentaire,
        };
        this.$store.commit('IS_LOADING', true);
        if (!isEmpty(process.env.VUE_APP_MIDDLE_EXTRACT_URL)) {
          this.$axios.defaults.baseURL = process.env.VUE_APP_MIDDLE_EXTRACT_URL;
        }
        this.$axios
          .post('/espaceGestion/extractions/fiche_tel_dgpo', data, {responseType: "arraybuffer"})
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.downloadExportedFile(response, 'fiche_tel_dgpo.xlsx');
          }).catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la génération du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              });
      },
      downloadExportedFile(response, filename) {
        let newBlob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        let link = document.createElement('a');
        link.href = data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100)

      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      onPaste(evt, type) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');
        if (type === 'receptionDebut' || type === 'clotureDebut') {
          this.dateReception = this.formatDate(pastedData);
          this.dateCloture = this.formatDate(pastedData);
        } else if (type === 'receptionAu' || type === 'clotureAu') {
          this.dateReceptionAu = this.formatDate(pastedData);
          this.dateClotureAu = this.formatDate(pastedData);
        }
      }
    }
  }
</script>
